import { useEffect } from "react";
import { disclosureFeed, stockFeed } from "../../../Services/Feed/FeedApiService";
import { useAuthHeader } from "../../../auth/AuthService";
import { useState } from "react";

export default function DisclosureFeed() {
    const authHeader = useAuthHeader();
    const [data, setData] = useState();

    function downloadURI() {
        let items = "";
        data?.map(v => {
            let lang = v.language == "1" ? "KH": "EN"
            items += `<item>
            <title>${v.title.trim()}</title>
            <description>${v.content.trim()}</description>
            <disclosure_date>${v?.ddisclosure}</disclosure_date>
            <transmission_date>${v?.tdate}</transmission_date>
            <language>${lang}</language>
            <pubDate>${v?.created}</pubDate>
        </item>
        `
        });


        var xmltext = `<rss xmlns:dc="http://purl.org/dc/elements/1.1/" version="2.0">
    <channel>
        <title>CSX Disclosure Feed</title>
        <link>${window.location.origin}</link>
        <description>CSX Disclosure Documents.</description>
        <language>en-us</language>
        ${items}
    </channel>
</rss>`;

        var filename = "disclosure.rss";
        var pom = document.createElement('a');
        var bb = new Blob([xmltext], {type: 'text/plain'});

        pom.setAttribute('href', window.URL.createObjectURL(bb));
        pom.setAttribute('download', filename);

        pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
        pom.draggable = true; 
        pom.classList.add('dragout');

        pom.click();
    }

    async function getIndex() {
        await disclosureFeed(authHeader())
        .then((response) => {
            setData(response?.data?.data);
        }) 
        .catch((error) => console.log(error))
    }

    useEffect(() => {
        getIndex();
    }, [])

    useEffect(() => {
        data?.length && downloadURI();
    }, [data?.length])
}